let currentVersion = null
let updateDetected = false
const listeners = []

export function onNewVersionAvailable(callback) {
  if (typeof callback === 'function') {
    listeners.push(callback)
    if (updateDetected) {
      callback()
    }
  }
}

export function notifyUpdate() {
  if (!updateDetected) {
    updateDetected = true
    listeners.forEach(cb => {
      try {
        cb()
      } catch (e) {
        // ignora erros em callbacks
      }
    })
  }
}

export async function checkAppVersion(onUpdateAvailable) {
  if (onUpdateAvailable) {
    onNewVersionAvailable(onUpdateAvailable)
  }

  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
      },
    })

    if (!response.ok) return

    const data = await response.json()

    if (!currentVersion) {
      currentVersion = data.version
      return
    }

    if (data && data.version && data.version !== currentVersion) {
      notifyUpdate()
    }
  } catch (err) {
    // Falha silenciosa caso offline ou erro temporário de rede
  }
}

export function reloadPage() {
  window.location.reload(true)
}

// Expose helper on window for easy testing in browser console
if (typeof window !== 'undefined') {
  window.versionCheck = {
    notifyUpdate,
    checkAppVersion,
    getCurrentVersion: () => currentVersion,
    setCurrentVersion: (v) => { currentVersion = v },
  }
}
